import { render } from "./NewsBar.vue?vue&type=template&id=7c186b6c&scoped=true"
import script from "./NewsBar.vue?vue&type=script&lang=js"
export * from "./NewsBar.vue?vue&type=script&lang=js"

import "./NewsBar.vue?vue&type=style&index=0&id=7c186b6c&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c186b6c"]])

export default __exports__